export async function getTokenCaptcha(action) {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      reject(new Error('reCAPTCHA is not loaded'));
      return;
    }

    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          '6LfQaLEZAAAAADfn62gMxrdNLxgixMQ_Hb5lLt2n',
          { action }
        );

        resolve(token);
      } catch (error) {
        reject(error);
      }
    });
  });
}